export default __webpack_public_path__ + "static/media/IMG_20200620_095454_237 - 571_Srijita Mallick.220bed52.jpg";